// extracted by mini-css-extract-plugin
module.exports = {"warning":"style_warning__Uu8a7","icon":"style_icon__1LaZT","content":"style_content__V8l4y"};